module.exports = require("@nestjs/terminus");